import React from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
export default class ProductPlace extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      item: {},
    };
  }
  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.product !== this.props.product) {
      this.load();
    }
  }

  load = async () => {
    this.setState({ item: { ...this.props.item } });
  };

  save = async () => {
    const { item } = this.state;
    this.setState({ pending: true });
    let saveData = {
      id: this.props.product,
      rack: item.rack,
      cell: item.cell,
    };
    let result = await this.context.api.q("/product/set", saveData);
    this.setState({ pending: false });
    if (result !== false) {
      this.context.toast("Изменения сохранены", "success");
      this.props.onAfterSave();
      this.props.onHide();
    } else {
      this.context.toast("Не удалось сохранить изменения", "error");
    }
  };

  onChange = (id, value) => {
    this.setState((state) => {
      let { item } = state;
      item[id] = value;
      return { item };
    });
  };

  render() {
    const { pending, item } = this.state;
    return (
      <Modal size="lg" show onHide={this.props.onHide}>
        <Modal.Header closeButton>
          <Modal.Title className="w-100">
            <div className="d-flex justify-content-between align-items-center">
              <div>{item.label}</div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Blocker on={pending} hAuto>
            <div className="form-group">
              <label>Полка:</label>
              <input
                type="text"
                value={item.rack || ""}
                className="form-control"
                onChange={(e) => this.onChange("rack", e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Ячейка:</label>
              <input
                type="text"
                value={item.cell || ""}
                className="form-control"
                onChange={(e) => this.onChange("cell", e.target.value)}
              />
            </div>
          </Blocker>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={this.save} className="btn btn-primary">
            Сохранить
          </button>
          <button onClick={this.props.onHide} className="btn btn-light">
            Отмена
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
